"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.icon = void 0;

var _tokens = require("./tokens");

var icon = {
  styles: function styles(_ref) {
    var target = _ref.target,
        color = _ref.color,
        size = _ref.size;
    return {
      color: (0, _tokens.generateTokenFn)({
        target: target,
        type: 'icon.color',
        tokenKey: 'color.textStyle',
        fallback: color
      }),
      height: (0, _tokens.generateTokenFn)({
        target: target,
        type: 'icon.size',
        tokenKey: 'icon.size',
        fallback: size
      }),
      width: (0, _tokens.generateTokenFn)({
        target: target,
        type: 'icon.size',
        tokenKey: 'icon.size',
        fallback: size
      })
    };
  },
  tokens: function tokens(_ref2) {
    var target = _ref2.target,
        color = _ref2.color,
        size = _ref2.size,
        svg = _ref2.svg;
    return {
      icon: {
        color: (0, _tokens.generateTokenFn)({
          target: target,
          type: 'icon.color',
          tokenKey: 'color.textStyle',
          fallback: color
        }),
        size: (0, _tokens.generateTokenFn)({
          target: target,
          type: 'icon.size',
          tokenKey: 'icon.size',
          fallback: size
        }),
        svg: (0, _tokens.generateTokenFn)({
          target: target,
          type: 'icon.svg',
          tokenKey: 'icon.svg',
          fallback: svg
        })
      }
    };
  }
};
exports.icon = icon;